"use client";

import styles from "./SafeArea.module.css";

export function SafeAreaTop(props: { children?: React.ReactNode }) {
  const safeAreaInset = window.ReactNativeWebView?.safeAreaInset;

  return (
    <div
      className={styles.top}
      style={safeAreaInset ? { paddingTop: `${safeAreaInset.top}px` } : {}}
    >
      {props.children}
    </div>
  );
}

export function SafeAreaBottom(props: { children?: React.ReactNode }) {
  const safeAreaInset =
    window !== undefined && window.ReactNativeWebView?.safeAreaInset;

  return (
    <div
      className={styles.bottom}
      style={
        safeAreaInset
          ? {
              paddingBottom: `${safeAreaInset.bottom}px`,
            }
          : {}
      }
    >
      {props.children}
    </div>
  );
}
